import { SearchOutlined } from '@ant-design/icons';
import { Checkbox, Input } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import classnames from 'classnames';
import React, { useMemo, useState } from 'react';
import { FormEntry } from '@/presentation/components/form';
import {
  FORM_EXCEPTION_INFORMATION,
} from '@/presentation/components/tds-form/tds-fields-filter/config';


export interface IFilterArrayProps {
  entries?: FormEntry[];
  defaultSelectedEntries: FormEntry[];
  onSelectedChange?: (entries: FormEntry[]) => void;
}

export const FilterArray = (props: IFilterArrayProps) => {
  const { entries = [], defaultSelectedEntries = [], onSelectedChange } = props;
  const [selectedEntries, setSelectedEntries] = useState<FormEntry[]>(defaultSelectedEntries);
  const [search, setSearch] = useState<string>('');
  const [selectAllChecked, setSelectAllChecked] = useState(selectedEntries.length >= entries.length);

  const isChecked = (entry: FormEntry) => selectedEntries
    .some((curEntry: FormEntry) => entry.name === curEntry.name);

  const indeterminate = selectedEntries.length > 0 && selectedEntries.length < entries.length;

  const handleSelectAllChange = (e: CheckboxChangeEvent) => {
    const { checked } = e.target;
    setSelectAllChecked(checked);
    const tempSelectedEntries = checked ? entries : [];
    setSelectedEntries?.(tempSelectedEntries);
    onSelectedChange?.(tempSelectedEntries);
  };

  // 异常信息
  const exceptionInformationList = useMemo(
    () => {
      const exceptionList = entries
        ?.filter((item) => {
          const label = item.labelString || (typeof (item.label) === 'string' ? item.label : '') || '';
          return FORM_EXCEPTION_INFORMATION.includes(label) && label.indexOf(search || '') > -1;
        });
      const otherList = entries
        ?.filter((item) => {
          const label = item.labelString || (typeof (item.label) === 'string' ? item.label : '') || '';
          return (!FORM_EXCEPTION_INFORMATION.includes(label))
            && (label).indexOf(search || '') > -1;
        }) || [];
      return exceptionList?.concat(otherList) || [];
    },
    [entries, search],
  );

  const searchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const onClick = (entry: FormEntry, checked: boolean) => {
    const tempSelectedEntries = [...selectedEntries];

    if (checked) {
      tempSelectedEntries.push(entry);
    } else {
      const filterIndex = tempSelectedEntries.findIndex((curFilter: FormEntry) => entry.name === curFilter.name);
      if (filterIndex !== -1) {
        tempSelectedEntries.splice(filterIndex, 1);
      }
    }
    setSelectAllChecked(tempSelectedEntries.length >= entries.length);
    setSelectedEntries(tempSelectedEntries);
    onSelectedChange?.(tempSelectedEntries);
  };

  return <div className={'flex flex-col gap-[16px] w-[300px]'}>
    <div className={'px-[12px]'}>
      <Input value={search} onChange={searchChange} placeholder={'搜索字段'} suffix={<SearchOutlined />} />
    </div>
    {exceptionInformationList?.length
      ? <div className={'flex gap-[8px] flex-wrap px-[12px]'}>{exceptionInformationList.map((item, index) => {
        const isSelect = isChecked(item);
        return <div key={index} onClick={() => onClick(item, !isSelect)} className={
          classnames({
            ['text-[12px] px-[8px] py-[2px] rounded-[2px] cursor-pointer']: true,
            ['text-[#4A5970] bg-[#EDF1F7]']: !isSelect,
            ['text-[#FFF] bg-[#0A6CFF]']: isSelect,
          })}>{item?.labelString || item?.label}</div>;
      })}</div> : null}
    <div className={'pt-[8px] border-t border-[#EDF1F7] border-solid px-[12px] flex justify-between'}>
      {!search ? <Checkbox
        checked={selectAllChecked}
        onChange={handleSelectAllChange}
        indeterminate={indeterminate}
      >全选</Checkbox> : <div/>}
    </div>
  </div>;
};
